module.exports = __webpack_public_path__ + "static/media/feature-filter-price.01bf6fba.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/feature-filter-price.png
// module id = 171
// module chunks = 0